import { Api } from '@monorepo/shared/apiClient';
import { MutationConfig, useMutation } from 'react-query';

type UseSyncAnalyticsDataNowParams = {
  config?: MutationConfig<Api.SyncAnalyticsDataNowResponse, Api.ErrorResponse>;
};

export const useSyncAnalyticsDataNow = (
  params?: UseSyncAnalyticsDataNowParams,
) =>
  useMutation(Api.syncAnalyticsDataNow, {
    ...params?.config,
    onSuccess: (analyticsSync, mutationFuncParams) =>
      params?.config?.onSuccess?.(analyticsSync, mutationFuncParams),
  });
